const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1025 1025",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4946,-2197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_10",
    transform: "matrix(1,0,0,1,4946.2,2197.02)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(214,140,42)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.877564,5.55112e-17,-5.55112e-17,0.877564,-4277.92,-1830.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5507.38,2489.44C5513.7,2489.44 5519.3,2493.51 5521.26,2499.53C5530.78,2529.15 5543.43,2560.14 5591.11,2598.35C5623.23,2624.09 5649.15,2688.43 5651.2,2740.95C5654.09,2814.62 5646.51,2903.57 5631.04,2968.72C5612.03,3048.85 5580.05,3057.37 5458.2,3057.37C5338.7,3057.23 5304.23,3048.22 5285.37,2968.72C5269.9,2903.57 5262.32,2814.62 5265.2,2740.95C5267.26,2688.43 5293.76,2624.8 5325.3,2598.35C5368.82,2561.85 5384.85,2529.33 5395.11,2499.32C5397.13,2493.42 5402.68,2489.45 5408.91,2489.45C5431.58,2489.44 5484.61,2489.44 5507.38,2489.44Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.932196,0,0,0.932196,-4576.12,-1974.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5389.76,2399.61C5400.41,2399.61 5410.15,2393.63 5414.98,2384.15C5426.35,2361.32 5435.48,2337.43 5443.2,2312.88C5445.31,2306.22 5451.47,2301.69 5458.45,2301.66C5465.43,2301.63 5471.63,2306.11 5473.8,2312.74C5481.59,2335.77 5491.38,2359.93 5503.19,2383.9C5507.96,2393.51 5517.77,2399.58 5528.51,2399.58C5529.57,2399.61 5530.23,2399.61 5530.23,2399.61C5546.1,2399.61 5558.98,2412.49 5558.98,2428.36C5558.98,2444.23 5546.1,2457.12 5530.23,2457.12L5386.18,2457.12C5370.31,2457.12 5357.43,2444.23 5357.43,2428.36C5357.43,2412.49 5370.31,2399.61 5386.18,2399.61L5389.76,2399.61Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.861598,0,0,1.06418,-4184.24,-2376.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5581.42,2832.67C5581.42,2814.79 5563.5,2800.28 5541.42,2800.28L5374.94,2800.28C5352.86,2800.28 5334.93,2814.79 5334.93,2832.67L5334.93,2897.44C5334.93,2915.32 5352.86,2929.83 5374.94,2929.83L5541.42,2929.83C5563.5,2929.83 5581.42,2915.32 5581.42,2897.44L5581.42,2832.67Z",
    style: {
      fill: "rgb(214,140,42)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.b0e6f2812c598b5077645eabf8bc13bf.svg";
export { ForwardRef as ReactComponent };